import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditGlobalRenamingPayload {
    settingId: string
    data: any
}

export interface IEditGlobalRenamingState {
    status: string
    data: any
    errors: any
}

const initialState: IEditGlobalRenamingState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editGlobalRenaming = createSlice({
    name: 'event-setting/edit-global-renaming',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditGlobalRenamingPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editGlobalRenamingActions = editGlobalRenaming.actions
export default editGlobalRenaming.reducer
